import { dec, somma, ZERO } from './dec'
import type { RigaMutabile } from './modello'
import type { Scaglioni } from './regole-periodo'

/**
 * Ripartisce i consumi di un mese sugli scaglioni. Le righe consumano la soglia
 * in ordine e quella che la attraversa si spezza in due. Se il totale del mese
 * supera la soglia alta cambiano i righi (in energix M6 e M7, importo fisso).
 */
export function ripartisciScaglioni(
  righe: readonly RigaMutabile[],
  scaglioni: Scaglioni,
  utenze: number,
): RigaMutabile[] {
  const moltiplicatore = dec(Math.max(utenze, 1))
  const soglia = scaglioni.soglia.times(moltiplicatore)
  const sogliaAlta = scaglioni.sogliaAlta.times(moltiplicatore)
  const totale = somma(...righe.map((r) => dec(r.kwh ?? 0)))
  const [rigoEntro, rigoOltre] = totale.lte(sogliaAlta) ? scaglioni.righi.entroAlta : scaglioni.righi.oltreAlta

  const out: RigaMutabile[] = []
  let cumulato = ZERO
  for (const r of righe) {
    const kwh = dec(r.kwh ?? 0)
    const disponibile = soglia.minus(cumulato)
    const entro = disponibile.lte(0) ? ZERO : kwh.lte(disponibile) ? kwh : disponibile
    const oltre = kwh.minus(entro)
    if (kwh.isZero()) out.push({ ...r, tipologia: rigoEntro })
    if (entro.gt(0)) out.push({ ...r, kwh: entro, tipologia: rigoEntro })
    if (oltre.gt(0)) out.push({ ...r, kwh: oltre, tipologia: rigoOltre })
    cumulato = cumulato.plus(kwh)
  }
  return out
}
